import React, {useEffect, useState} from 'react';
import View from './view';
import {KidSubform} from '../model';
import {InjectedFormProps, getFormValues, initialize, reduxForm} from 'redux-form';
import {Forms} from '../../../../../../shared/models/forms';
import {mapFormValuesToEsiaRegData, mapUseRegCardStateKidToFormValues} from '../../formMapper';
import {validationPipe} from '../../../../../../shared/pipes';
import {validationItems} from './constants';
import {useDispatch, useSelector} from 'react-redux';
import {useRegCardState} from '../../../esiaRegCardState/useRegCardState';

interface KidsubformProps {
  kidId: number;
}

const getFormErrors = (formData: KidSubform) => {
  return validationPipe(formData, validationItems);
};

function _KidSubform({kidId}: KidsubformProps & InjectedFormProps<KidSubform, KidsubformProps>) {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => {
    return getFormValues(`${Forms.kidSubform}-${kidId.toString()}`)(state) as KidSubform;
  });
  const {checkedKids, parent} = useRegCardState();
  const [submitting, setSubmitting] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [submissionErrors, setSubmissionErrors] = useState(null);
  const onAcceptedToggle = () => setIsAccepted((prev) => !prev);

  useEffect(() => {
    if (parent && !formValues)
      dispatch(
        initialize(
          `${Forms.kidSubform}-${kidId.toString()}`,
          mapUseRegCardStateKidToFormValues(parent, checkedKids[kidId]),
        ),
      );
  }, [checkedKids]);

  useEffect(() => {
    if (!formValues) return;
    const submissionData = mapFormValuesToEsiaRegData(formValues);
    const errors = getFormErrors(submissionData);
    if (errors) {
      setSubmissionErrors(errors);
    }
  }, [formValues]);

  return (
    <View
      kidId={kidId}
      formValues={formValues}
      isAccepted={isAccepted}
      onAcceptedToggle={onAcceptedToggle}
      loading={false}
      submissionErrors={submissionErrors}
      setSubmissionErrors={setSubmissionErrors}
      onSubmit={() => {}}
      submitting={submitting}
    />
  );
}

export const createKidSubformWithDynamicName = (formId: number) => {
  return reduxForm<KidSubform, KidsubformProps>({
    form: `${Forms.kidSubform}-${formId}`, // Dynamic form name
    destroyOnUnmount: false,
    keepValues: true,
  })(_KidSubform);
};
